import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=3e2a3d5d"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e2a3d5d')) {
      api.createRecord('3e2a3d5d', component.options)
    } else {
      api.reload('3e2a3d5d', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=3e2a3d5d", function () {
      api.rerender('3e2a3d5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/cooperative-members/edit.vue"
export default component.exports